export enum VerificationType {
    identity = 'identity',
    business = 'business',
    residence = 'residence',
}
